import type { TimingStatus } from "./types";

export function isTimingStatus(value: unknown): value is TimingStatus {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as Partial<TimingStatus>;
  return (
    candidate.state === "green" ||
    candidate.state === "yellow" ||
    candidate.state === "red"
  );
}

export function formatTimingStatus(status: TimingStatus | null | undefined): {
  label: string;
  description?: string;
  color: "green" | "yellow" | "red";
} {
  if (!status) {
    return {
      label: "Unbekannt",
      description: "Keine Timing-Informationen verfügbar.",
      color: "yellow"
    };
  }

  // Vereinfache das Label: entferne Anzahl der Zeitfenster
  let simplifiedLabel = status.label || "Unbekannt";
  
  // Prüfe auf "zu früh" Muster (z.B. "2 Zeitfenster zu früh", "Ein Zeitfenster zu früh")
  if (/zeitfenster\s+zu\s+früh/i.test(simplifiedLabel) || /zu\s+früh/i.test(simplifiedLabel)) {
    simplifiedLabel = "Zu früh";
  }
  // Prüfe auf "zu spät" Muster (z.B. "2 Zeitfenster zu spät", "Ein Zeitfenster zu spät")
  else if (/zeitfenster\s+zu\s+spät/i.test(simplifiedLabel) || /zu\s+spät/i.test(simplifiedLabel)) {
    simplifiedLabel = "Zu spät";
  }
  // Prüfe auf "pünktlich" / "im Zeitfenster" Muster
  else if (/im\s+(gebuchten\s+)?zeitfenster/i.test(simplifiedLabel) || /pünktlich/i.test(simplifiedLabel) || /nach\s+wartezeit/i.test(simplifiedLabel)) {
    simplifiedLabel = "Pünktlich";
  }

  const base = {
    label: simplifiedLabel,
    description: status.description,
    color: status.state
  } as const;

  switch (status.state) {
    case "green":
      return { ...base, color: "green" };
    case "yellow":
      return { ...base, color: "yellow" };
    case "red":
      return { ...base, color: "red" };
    default:
      return { ...base, color: "yellow" };
  }
}
